(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inksake-cinematic-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('inksake-brand-film')) {
    customElements.define('inksake-brand-film', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('button');
        this.label = this.toggle.querySelector('span');
        this.mobile = matchMedia('(max-width: 749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.reducedData = matchMedia('(prefers-reduced-data: reduce)');
        this.userPaused = false;
        this.visible = true;
        this.video.muted = true;
        this.toggle.hidden = false;
        const syncLabel = () => {
          this.label.textContent = this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
          this.toggle.dataset.paused = String(this.video.paused);
        };
        this.video.addEventListener('playing', () => {
          this.setAttribute('data-has-frame', '');
          syncLabel();
        }, { signal });
        this.video.addEventListener('pause', syncLabel, { signal });
        this.video.addEventListener('error', () => {
          this.removeAttribute('data-has-frame');
          this.video.pause();
          syncLabel();
        }, { signal });
        this.toggle.addEventListener('click', () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.playFilm();
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        }, { signal });
        this.mobile.addEventListener('change', () => {
          const wasPlaying = !this.video.paused;
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.load();
          this.removeAttribute('data-has-frame');
          if (wasPlaying && !this.reduced.matches && !this.dataSaving()) this.playFilm();
        }, { signal });
        this.reducedData.addEventListener('change', () => {
          if (this.dataSaving()) {
            this.video.pause();
            this.removeAttribute('data-has-frame');
          }
        }, { signal });
        this.reduced.addEventListener('change', () => {
          if (this.reduced.matches) {
            this.video.pause();
            this.removeAttribute('data-has-frame');
          }
        }, { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video.pause();
          else if (this.mayAutoplay()) this.playFilm();
        }, { signal });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (!this.visible) this.video.pause();
          else if (this.mayAutoplay()) this.playFilm();
        }, { threshold: 0.15 });
        this.observer.observe(this);
        syncLabel();
        if (this.mayAutoplay()) this.playFilm();
      }
      dataSaving() {
        const connection = navigator.connection;
        return Boolean(this.reducedData.matches || connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || '')));
      }
      mayAutoplay() {
        return this.dataset.autoplay === 'true' && !this.reduced.matches && !this.dataSaving() && !this.userPaused && this.visible && !document.hidden;
      }
      playFilm() {
        const src = this.mobile.matches ? this.dataset.mobileSrc : this.dataset.desktopSrc;
        if (!src) return;
        if (!this.video.getAttribute('src')) {
          this.video.src = src;
          this.video.load();
        }
        this.video.play().catch(() => {
          this.label.textContent = this.dataset.playLabel;
        });
      }
      disconnectedCallback() {
        this.video?.pause();
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inksake-delivery-summary"] && !Shopify.designMode) return;
  try {
    function estimateInksakeArrivalV2(minimum, maximum, now = new Date(), unit = 'business') {
  if (!/^\d{1,2}$/.test(String(minimum)) || !/^\d{1,2}$/.test(String(maximum))) return null;
  const min = Number(minimum), max = Number(maximum);
  if (min < 1 || max < min || max > 60) return null;
  const parts = new Intl.DateTimeFormat('en-US', {timeZone:'America/Chicago', year:'numeric', month:'2-digit', day:'2-digit'}).formatToParts(now);
  const v = Object.fromEntries(parts.map(p => [p.type,p.value]));
  const date = new Date(`${v.year}-${v.month}-${v.day}T12:00:00Z`);
  const add = amount => {
    const result = new Date(+date);
    let counted = 0;
    while (counted < amount) {
      result.setUTCDate(result.getUTCDate()+1);
      if (unit === 'calendar' || (result.getUTCDay() !== 0 && result.getUTCDay() !== 6)) counted++;
    }
    return result;
  };
  const latest = add(max), earliest = add(min);
  const showYear = earliest.getUTCFullYear() !== +v.year || latest.getUTCFullYear() !== +v.year;
  const calendarRange = (a, b) => {
    if (a.getUTCFullYear() !== b.getUTCFullYear()) return `${fmt(a)}–${fmt(b)}`;
    const short = d => new Intl.DateTimeFormat('en-US',{timeZone:'UTC',month:'short',day:'numeric'}).format(d);
    return a.getUTCMonth() === b.getUTCMonth() ? `${short(a)}–${b.getUTCDate()}` : `${short(a)}–${short(b)}`;
  };
  const fmt = d => new Intl.DateTimeFormat('en-US',{timeZone:'UTC',month:'short',day:'numeric',...(showYear?{year:'numeric'}:{})}).format(d);
  return {earliest:earliest.toISOString().slice(0,10),latest:latest.toISOString().slice(0,10),label:+earliest===+latest?fmt(earliest):unit==='calendar'?calendarRange(earliest,latest):`${fmt(earliest)}–${fmt(latest)}`,as_of:`${v.year}-${v.month}-${v.day}`,timezone:'America/Chicago'};
}


  const updateInksakeArrivalV2 = () => {
    document.querySelectorAll('[data-inksake-arrival-v2]').forEach(panel => {
      const label = panel.querySelector('[data-inksake-arrival-v2-label]');
      if (!label) return;
      let result = null;
      try { result = estimateInksakeArrivalV2(panel.dataset.inksakeArrivalV2Min, panel.dataset.inksakeArrivalV2Max, new Date(), panel.dataset.inksakeArrivalV2Unit === 'calendar' ? 'calendar' : 'business'); } catch {}
      const next = result ? result.label : label.textContent;
      if (label.textContent !== next) label.textContent = next;
    });
  };
  updateInksakeArrivalV2();
  document.addEventListener('shopify:section:load', updateInksakeArrivalV2);
  window.addEventListener('pageshow', updateInksakeArrivalV2);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateInksakeArrivalV2(); });
  const arrivalObserverV2 = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('[data-inksake-arrival-v2]') || node.querySelector?.('[data-inksake-arrival-v2]'))))) updateInksakeArrivalV2();
  });
  arrivalObserverV2.observe(document.body, { childList: true, subtree: true });
  window.setInterval(() => { if (!document.hidden) updateInksakeArrivalV2(); }, 60000);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inksake-launch-text-fields"] && !Shopify.designMode) return;
  try {
    function clampInksakeLaunchText(field) {
    const limit = Number(field.dataset.inksakeTextLimit);
    if (!(limit > 0)) return;
    const chars = Array.from(field.value);
    if (chars.length <= limit) return;
    const end = field.selectionEnd;
    field.value = chars.slice(0, limit).join('');
    if (typeof end === 'number') { const pos = Math.min(end, field.value.length); try { field.setSelectionRange(pos, pos); } catch (e) {} }
  }

  function validateInksakeLaunchText(field, trim) {
    const initials = field.hasAttribute('data-inksake-initials');
    const exactSingleLine = field.hasAttribute('data-inksake-single-line-exact');
    const value = initials || exactSingleLine ? field.value : field.value.trim();
    if (trim && !initials && !exactSingleLine) field.value = value;
    if (field.hasAttribute('data-inksake-optional') && !value.trim()) { field.setCustomValidity(''); return true; }
    const length = field.hasAttribute('data-inksake-unicode-limit') ? Array.from(value).length : value.length;
    const minValue = field.dataset.inksakeMinValue, maxValue = field.dataset.inksakeMaxValue;
    if ((minValue || maxValue) && /^[0-9]+$/.test(value.trim())) {
      const n = Number(value.trim());
      if ((minValue && n < Number(minValue)) || (maxValue && n > Number(maxValue))) { field.setCustomValidity(field.dataset.rangeError || field.dataset.limitError || ''); return false; }
    }
    const error = (exactSingleLine ? !value.trim() : !value) ? field.dataset.requiredError : exactSingleLine && /[\r\n\u2028\u2029]/.test(value) ? field.dataset.formatError : length > Number(field.dataset.inksakeTextLimit) ? field.dataset.limitError : initials && !Array.from(value).every((character) => character >= 'A' && character <= 'Z') ? field.dataset.formatError : '';
    field.setCustomValidity(error || '');
    return !error;
  }

  function syncInksakeFontCode(select) {
    const code = select.selectedOptions[0] ? select.selectedOptions[0].dataset.fontCode : '';
    const input = select.closest('form') && select.closest('form').querySelector('[data-inksake-font-code-input]');
    if (input) input.value = /^F0[1-5]$/.test(code || '') ? code : '';
  }

  document.addEventListener('input', (event) => {
    const field = event.target;
    if ((field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement) && field.matches('[data-inksake-launch-text] [data-inksake-text-limit]')) {
      clampInksakeLaunchText(field);
      validateInksakeLaunchText(field, false);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLSelectElement && event.target.matches('[data-inksake-allowed-fonts]')) {
      event.target.setCustomValidity('');
      syncInksakeFontCode(event.target);
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.querySelector('[data-inksake-text-font-invalid]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const font = form.querySelector('[data-inksake-allowed-fonts]');
    if (font instanceof HTMLSelectElement) {
      const allowedFonts = font.dataset.inksakeAllowedFonts.split(',');
      const fontValid = allowedFonts.includes(font.value) && font.selectedOptions[0] && /^F0[1-5]$/.test(font.selectedOptions[0].dataset.fontCode || '');
      font.setCustomValidity(fontValid ? '' : font.dataset.fontError);
      if (fontValid) syncInksakeFontCode(font);
    }
    const inputs = form.querySelectorAll('[data-inksake-launch-text] [data-inksake-text-limit]');
    if (!inputs.length) return;
    let valid = true;
    inputs.forEach((field) => { clampInksakeLaunchText(field); if (!validateInksakeLaunchText(field, true)) valid = false; });
    if (!valid || !form.reportValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
